import React, { memo } from 'react'
import { func, number, string, oneOfType } from 'prop-types'

import range from 'lodash/range'

import classNames from 'src/common/helpers/class-names'
import { showAdapter } from 'shared/util/element/adapters'
import { getCurrentOS } from 'shared/util/env'

import './_rating-stars.scss'


const blk = 'rating-stars'

const Stars = memo(({ position, mix, ...rest }) => (
  <div
    {...rest}
    className={classNames({
      blk, elt: 'stars', mods: [position], mix,
    })}
    aria-hidden="true"
  >
    {range(0, 5).map(i => <span key={`rate-star-${i}`} aria-hidden="true">★</span>)}
  </div>
))

Stars.propTypes = {
  position: string,
  mix: string,
}

Stars.defaultProps = {
  position: '',
  mix: '',
}

const RatingStars = (props) => {
  const {
    mix, size, handleRatingClick, avgStarRating, reviewCount, percentage,
  } = props
  const isWindows = getCurrentOS() === 'Windows'
  const displayBlackStars = (avgStarRating === 5)
  const sizeMods = [size, isWindows && 'windows']

  const getRatingWidth = () => (typeof percentage === 'number'
    ? { width: `${percentage}%` }
    : undefined)

  return (
    <div
      onClick={handleRatingClick}
      onKeyPress={handleRatingClick}
      role="button"
      tabIndex="0"
      className={classNames({ className: mix, blk, mods: sizeMods })}
      aria-label={
        `${avgStarRating} stars out of 5 based on ${reviewCount} reviews, you will be taken to the reviews on clicking this`
      }
    >
      <Stars mix={mix} position="top" style={getRatingWidth()} />
      {!displayBlackStars && <Stars mix={mix} position="bottom" />}
    </div>
  )
}

RatingStars.propTypes = {
  mix: string,
  size: string,
  handleRatingClick: func,
  avgStarRating: number,
  reviewCount: oneOfType([number, string]),
  percentage: number,
}

RatingStars.defaultProps = {
  mix: undefined,
  size: undefined,
  handleRatingClick() {},
  avgStarRating: 0,
  reviewCount: 0,
  percentage: undefined,
}

const RatingStarsWithAdapter = showAdapter(RatingStars)

export {
  RatingStarsWithAdapter as default,
  RatingStars,
  Stars,
}



// WEBPACK FOOTER //
// ./shared/interim/product/rating/rating-stars.js